import React from 'react';
function Description(_ref) {
  var description = _ref.description;
  return /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description);
}
export default Description;